export default __webpack_public_path__ + "locales/ro/Common.json?hash=5a3268797ef7baf7512137dd23484369";